import React, {Component} from 'react';
import IconButton from '@mui/material/IconButton';
import {withStyles} from '@mui/styles';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import Link from '@mui/material/Link';

const styles = theme => ({});

const INITIAL_STATE = {
    showDialog: false,
};

class EmailButton extends Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;
    };

    render() {

        const { anchorEl } = this.state;
        const metadataKey = this.props.actionConfig.metadataKey;
        const templateKey = this.props.actionConfig.templateKey;
        const emailAddress = ( metadataKey && templateKey) && this.props.folderDetails[templateKey + "~" + metadataKey];

        return (
            <div style={{display: "inline"}}>
                <Tooltip title={this.props.actionConfig.label}>
                    <Link
                        href={"mailto:"+ (emailAddress ? emailAddress : "")}
                        target="_blank"
                        underline="hover">
                        <IconButton
                            aria-label="Menu"
                            aria-owns={anchorEl ? 'simple-menu' : undefined}
                            aria-haspopup="true"
                            color = "secondary"
                            size="medium">
                            <i className='material-icons'>
                                mail
                            </i>
                        </IconButton>
                    </Link>
                </Tooltip>

            </div>
        );
    }
}

EmailButton.propTypes = {
    folderDetails: PropTypes.object.isRequired,
    actionConfig: PropTypes.object.isRequired
};

export default withStyles(styles)(EmailButton);